import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UiInputComponent, UiInputKind } from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

@Component({
  selector: 'app-input-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiInputComponent, AppExampleSectionComponent],
  templateUrl: './input-doc.component.html',
  styleUrl: './input-doc.component.scss',
})
export class InputDocComponent {
  protected readonly kinds: UiInputKind[] = [
    'text',
    'number',
    'amount',
    'nss',
    'email',
    'password',
    'search',
    'url',
  ];

  protected readonly isInvalid = signal(false);
  protected readonly showErrorMsg = signal(true);
  protected readonly demoPassword = signal('');
  protected readonly demoConfirmPassword = signal('');

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }

  protected toggleErrorMsg(): void {
    this.showErrorMsg.update((v) => !v);
  }
}
